module.exports = __webpack_public_path__ + "static/media/no_items_found.a47d4d2e.png";